/**
 * Chemins des fichiers de marque servis au navigateur.
 *
 * Ce sont des chemins relatifs à la racine du site, jamais des URLs absolues
 * (§7 bis). Les fichiers sont copiés depuis brand/ par scripts/synchroniser-marque.sh :
 * aucun composant ne référence brand/ directement, ce qui permet de changer de
 * concept de logo en modifiant ce seul fichier (ADR 0002).
 */
export const marque = {
    /** Lockup complet — en-tête et fonds clairs. Livraison 2026-08-20, 900 × 227. */
    lockupClair: '/marque/lockup-clair.png',
    /** Lockup vertical — usages carrés. Livraison 2026-08-20, 700 × 688. */
    lockupVertical: '/marque/lockup-vertical.png',
    /** Lockup du kit précédent, en SVG. Conservé pour l'impression une couleur. */
    lockupClairVectoriel: '/marque/lockup-clair.svg',
    /** Lockup complet — fonds sombres. Dérivé de la livraison 2026-08-20, 900 × 227. */
    lockupSombre: '/marque/lockup-sombre.png',
    /** Lockup vertical sur fond sombre. 700 × 688. */
    lockupVerticalSombre: '/marque/lockup-vertical-sombre.png',
    /** Lockup sombre du kit précédent, en SVG. Impression une couleur. */
    lockupSombreVectoriel: '/marque/lockup-sombre.svg',
    /** Signe seul — fond clair. 160 × 160. */
    monogrammeClair: '/marque/monogramme-clair.svg',
    /** Signe seul — fond sombre. 160 × 160. */
    monogrammeSombre: '/marque/monogramme-sombre.svg',
    favicon: '/marque/favicon.svg',
    faviconIco: '/marque/favicon.ico',
    favicon32: '/marque/favicon-32.png',
    favicon192: '/marque/favicon-192.png',
    favicon512: '/marque/favicon-512.png',
    appleTouchIcon: '/marque/apple-touch-icon.png',
    /** Image de partage Open Graph. 1200 × 630. */
    partageOg: '/marque/partage-og.png',
};
/** Dimensions natives, pour réserver la place et éviter tout décalage de mise en page. */
export const dimensionsMarque = {
    lockup: { largeur: 900, hauteur: 227 },
    lockupVertical: { largeur: 700, hauteur: 688 },
    lockupSombre: { largeur: 900, hauteur: 227 },
    monogramme: { largeur: 160, hauteur: 160 },
    partageOg: { largeur: 1200, hauteur: 630 },
};
/**
 * Texte alternatif du logo. Le nom de la marque n'est pas traduit ; il ne passe
 * donc pas par packages/i18n.
 */
export const texteAlternatifMarque = 'EF2C Campus Innovation';
//# sourceMappingURL=marque.js.map